import { useTranslation } from 'react-i18next';

import { useHistory } from '@treams/treams-routes';

import { Modal } from '@treams/treams-ui';
import ThankYouModal from 'packages/kakapo-ui-kit/components/modals/ThankYouModal';

import FeedbackCreateThankYouState from 'packages/kakapo-ui-kit/assets/illustrations/FeedbackCreateThankYouState.svg?url';

export default function FeedbackRequestThankYou(props: {
	returnURL: string;
	numberOfRecipients: number;
}) {
	const { t } = useTranslation();
	const history = useHistory();

	return (
		<Modal>
			<Modal.Header title={t('common.feedback.feedbackSent')} />

			<Modal.Contents>
				<ThankYouModal
					title={t('common.feedback.feedbackRequestSentToNumberOfRecipients', {
						numberOfRecipients: props.numberOfRecipients,
					})}
					buttonTitle={
						props.returnURL.includes('competencies')
							? t('common.feedback.backToCompetencies')
							: t('common.feedback.backToFeedbackOverview')
					}
					imageSrc={FeedbackCreateThankYouState}
					onClick={() => history.push(props.returnURL)}
				/>
			</Modal.Contents>
		</Modal>
	);
}
